module.exports = __webpack_public_path__ + "img/alphabund_mid.726a2867.jpeg";